import { CircularProgress, Paper } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import CustomSearch from "../../Common/CustomSearch";
import ErrorMessage from "../../Common/ErrorMessage";
import userService from "../../services/user.service";
import { getFromLocalStorage } from "../../utils/webStorage";
import StorageApprovalPopup from "./StorageApprovalPopup";
import SuperAdminDashboard from "./superAdminDashboard";
import PageNotFoundPage from "../../Common/PageNotFoundPage";

const Storage = () => {
  const [hoursRequestData, setHoursRequestData] = useState([]);
  const [request, setRequest] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
  });
  const schoolId = getFromLocalStorage("schoolId");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchedRecord, setSearchedRecord] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const loginRole = getFromLocalStorage("loginRole");
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    getHoursRequestData();
  }, []);

  const getHoursRequestData = () => {
    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    userService
      .getAddHoursRequest()
      .then((res) => {
        const data = res.data.data;
        const totalRequest = data.schoolAdminSportDetailsResponses.filter(
          (data) => data.hoursPurchasedPending
        );
        setHoursRequestData(data.schoolAdminSportDetailsResponses);
        setPageState((old) => ({
          ...old,
          isLoading: false,
          data: data.schoolAdminSportDetailsResponses,
        }));
        setRequest(totalRequest.length);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getStorageByPage = (page, size) => {
    setPageState((old) => ({ ...old, isLoading: true }));
    userService.getAllTeamAdminsByPage(schoolId, page, size).then((res) => {
      setPageState((old) => ({
        ...old,
        isLoading: false,
        data: res.data.data.teamAdminResponses,
        total: res.data.data.total,
      }));
      setLoading(false);
      if (recordNotFound) {
        setRecordNotFound(false);
      }
    });
  };

  const searchStorageData = (query) => {
    setPageState((old) => ({
      ...old,
      isLoading: true,
    }));
    setSearchQuery(query);
    if (!searchedRecord) {
      setSearchedRecord(true);
    }
    userService
      .searchStorageData(query)
      .then((res) => {
        const { data } = res.data;
        setHoursRequestData(res.data.data.schoolAdminSportDetailsResponses);
        setPageState({
          isLoading: false,
          data: res.data.data.schoolAdminSportDetailsResponses,
        });
        data.schoolAdminSportDetailsResponses.length == 0
          ? setRecordNotFound(true)
          : setRecordNotFound(false);
      })
      .catch((err) => {
        setRecordNotFound(true);
      });
  };

  const tableColumns = [
    {
      field: "schoolName",
      headerName: "School Name",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (
        <div className="d-flex-align-cent height-70 w-100 padding-left-10 padding-right-10">
          <p className="link-blue text-width-auto mg-auto">
            {params.row.schoolName}
          </p>
        </div>
      ),
    },
    {
      field: "totalDuration",
      headerName: "Total Storage (In Hour)",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
    },
    {
      field: "usedDuration",
      headerName: "Used Storage (In Hour)",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
      renderCell: (params) => <span>{params.row.usedDuration.toFixed(3)}</span>,
    },
    {
      field: "availableHours",
      headerName: "Available Storage (In Hour)",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 130,
      align: "center",
      renderCell: (params) => (
        <span> {params.row.availableHours.toFixed(3)}</span>
      ),
    },
    {
      headerName: "Requests",
      headerAlign: "center",
      headerClassName: "table-header bold",
      flex: 1,
      minWidth: 150,
      align: "center",
      renderCell: (params) => (
        <StorageApprovalPopup
          rowData={params.row}
          getHoursRequestData={getHoursRequestData}
        />
      ),
    },
  ];

  return (
    <>
      {loginRole === "SUPER ADMIN" ? (
        <div>
          <div className="content">
            <SuperAdminDashboard />
            <div className="content-layout pt-20">
              <div className="mng-header  ">
                <div className="fs-20 black bold ">
                  <h4 className="fs-24 bold mob-hd">
                    STORAGE ({hoursRequestData.length}){" "}
                  </h4>
                </div>
                <span className="fs-20 black bold ml-14">
                  Hours Purchase Request ({request ? request : 0})
                </span>
              </div>
              {loading && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr pt-1">
                {!loading && (pageState.data.length > 0 || recordNotFound) && (
                  <Paper className="pad-top-20 mg-bottom-20">
                    <CustomSearch
                      searchQuery={searchQuery}
                      searchedRecord={searchedRecord}
                      setSearchedRecord={setSearchedRecord}
                      setSearchQuery={setSearchQuery}
                      getDataByPage={getHoursRequestData}
                      searchData={searchStorageData}
                      pageState={pageState}
                      setRecordNotFound={setRecordNotFound}
                    />
                    <DataGrid
                      rows={pageState.data}
                      columns={tableColumns}
                      pageSize={10}
                      loading={pageState.isLoading}
                      rowsPerPageOptions={[10]}
                      autoHeight
                      disableColumnMenu
                      getRowHeight={() => "auto"}
                      getRowId={(row) => row.schoolId}
                      disableSelectionOnClick
                      sx={{
                        color: "black",
                        fontFamily: "Rajdhani-SemiBold",
                        fontSize: "18px",
                        backgroundColor: "white",
                        borderBottomLeftRadius: "12px",
                        borderBottomRightRadius: "12px",
                      }}
                      onCellClick={(params) => {
                        history.push(
                          `/schoolnamescreen/${params.row.schoolId}/${true}`
                        );
                      }}
                    />
                  </Paper>
                )}
                {!loading && !pageState.data.length > 0 && !recordNotFound && (
                  <ErrorMessage />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default Storage;
